import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import React from "react";
import { omitNonReactProps } from "~/services/utils";
import theme from "~/styles/theme";
var Hopin = function(_param) /*#__PURE__*/ {
    var fill = _param.fill, size = _param.size, otherProps = _object_without_properties(_param, [
        "fill",
        "size"
    ]);
    return _jsxs("svg", _object_spread_props(_object_spread({
        focusable: "false",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: fill
    }, omitNonReactProps(otherProps)), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M14.1539 5.75345C14.1303 6.68599 13.4683 8.01485 12.3571 8.01485C11.6715 8.01485 11.1041 7.45532 11.1041 6.77925V6.75593C11.0805 5.6602 10.584 4.70436 9.8038 4.02827C9.21276 3.53868 8.47985 3.2123 7.67603 3.11904C8.36164 2.41964 9.33096 2 10.3949 2C11.7424 2 12.9718 2.76934 13.6811 3.88839C14.0121 4.4479 14.1776 5.12399 14.1539 5.75345Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.75662 5.84697C10.3477 6.593 10.7023 8.01511 9.85119 8.71452C9.30743 9.15747 8.52724 9.08753 8.07805 8.57464C7.34515 7.75867 6.32855 7.33903 5.31194 7.31572C4.53175 7.2924 3.75157 7.52553 3.0896 7.96849C3.16052 7.01264 3.60972 6.05679 4.43718 5.3807C5.50107 4.51811 6.99052 4.26166 8.26718 4.77455C8.85824 4.98437 9.37836 5.35739 9.75662 5.84697Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.44658 8.69051C7.36861 8.87701 8.59799 9.76292 8.40886 10.8353C8.29064 11.5114 7.62867 11.9544 6.94306 11.8378H6.91941C5.83189 11.6746 4.768 12.001 3.98782 12.6305C3.39677 13.0967 2.92393 13.7728 2.71115 14.5422C2.14374 13.7495 1.88368 12.747 2.04918 11.6979C2.30924 10.3691 3.27856 9.25003 4.60251 8.80707C5.19355 8.62056 5.85552 8.57394 6.44658 8.69051Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.76115 12.9803C6.58861 12.5373 8.1017 12.4441 8.64547 13.3766C9.0001 13.9594 8.78731 14.7287 8.19627 15.0784C7.25059 15.638 6.65955 16.5472 6.44676 17.5497C6.30492 18.2957 6.37584 19.0883 6.73047 19.8111C5.78479 19.5779 4.91004 18.9718 4.38991 18.0625C3.70429 16.8736 3.72794 15.4049 4.4372 14.2391C4.76818 13.7029 5.21738 13.26 5.76115 12.9803Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.03064 16.687C8.38527 15.8244 9.4728 14.7986 10.4894 15.1716C11.1514 15.4047 11.4824 16.1274 11.2459 16.7569C10.8913 17.7828 11.0332 18.8551 11.5296 19.741C11.9079 20.4171 12.4753 20.9533 13.2083 21.303C12.3098 21.7227 11.2696 21.8159 10.2766 21.4429C8.97631 20.9766 8.03064 19.8343 7.81786 18.4821C7.74693 17.876 7.81786 17.2465 8.03064 16.687Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.1918 18.086C11.8844 17.2001 12.0499 15.7313 13.0902 15.3583C13.7521 15.1252 14.4613 15.4516 14.6978 16.1043C15.0997 17.1068 15.9035 17.8528 16.8728 18.2259C17.5822 18.5056 18.4096 18.5522 19.1898 18.3657C18.7879 19.2516 18.0314 19.9744 17.0384 20.3473C15.738 20.8136 14.2486 20.5338 13.232 19.6247C12.7592 19.1817 12.3809 18.6688 12.1918 18.086Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.3055 16.5242C15.5017 16.0347 14.6505 14.7991 15.218 13.8666C15.5726 13.2837 16.3292 13.0739 16.9438 13.4002C17.9132 13.9131 19.0007 13.9831 19.9937 13.6567C20.7265 13.4002 21.3886 12.934 21.8614 12.2812C22.1214 13.2137 22.0269 14.2396 21.4831 15.1488C20.7975 16.3377 19.4735 17.0605 18.1023 17.0139C17.4403 17.0139 16.802 16.8506 16.3055 16.5242Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18.4333 12.724C17.4876 12.8639 16.0454 12.4443 15.8563 11.3718C15.7144 10.7191 16.1873 10.0663 16.8729 9.94973H16.8966C17.9841 9.7399 18.8588 9.08713 19.3789 8.22454C19.7808 7.57176 19.97 6.80242 19.899 6.00977C20.7029 6.54597 21.3175 7.40857 21.4831 8.43435C21.7195 9.76322 21.1757 11.162 20.1118 12.0013C19.6154 12.3743 19.0243 12.6541 18.4333 12.724Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.582 8.48101C16.9436 9.18042 15.5725 9.78657 14.7213 9.08716C14.1776 8.64421 14.1067 7.87486 14.5559 7.33866C15.2415 6.49938 15.5016 5.42697 15.336 4.42449C15.2178 3.67846 14.8632 2.95574 14.2958 2.37291C15.2651 2.27966 16.2817 2.55942 17.1092 3.2355C18.1731 4.09809 18.6696 5.52021 18.3858 6.84907C18.2676 7.45522 17.9839 8.03806 17.582 8.48101Z"
            })
        ]
    }));
};
Hopin.propTypes = {
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};
Hopin.defaultProps = {
    size: 24,
    fill: theme.colors.icon
};
export default Hopin;
